/** A shimmering placeholder in the shape of what is loading. The Screen shell draws these; pages rarely need to. */
import s from './Skeleton.module.css'

export function Skeleton({ width = '100%', height = 'line' }: { width?: string; height?: 'line' | 'title' | 'block' }) {
  return <span className={`${s.sk} ${s[height]}`} style={{ width }} aria-hidden="true" />
}
